const PrivacyScreen = () => {

    return(
        <p>Privacy Screen</p>
    )
    
}

export default PrivacyScreen